export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-tablet-portrait-63076c522a75fe4fe4b9f25afa06b87b.svg";